import * as yup from "yup";

export type ResetPasswordFormValues = {
  password: string;
  confirmPassword: string;
};

export const ResetPasswordValidationSchema = yup.object({
  password: yup
    .string()
    .required("Вкажіть пароль")
    .min(6, "Пароль має містити більше 6-ти символів"),
  confirmPassword: yup
    .string()
    .required("Вкажіть пароль")
    .min(6, "Пароль має містити більше 6-ти символів")
    .oneOf([yup.ref("password")], "Паролі не співпадають"),
});
